import { render, staticRenderFns } from "./WelcomeQuickCourses.vue?vue&type=template&id=8c85e928"
import script from "./WelcomeQuickCourses.vue?vue&type=script&lang=js"
export * from "./WelcomeQuickCourses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports